"use strict";
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        var charts;
        (function (charts) {
            const chartInstances = {};
            const renderFrames = {};
            const chartObservers = {};
            function disposeAll() {
                Object.keys(chartInstances).forEach(id => {
                    var _a;
                    (_a = chartInstances[id]) === null || _a === void 0 ? void 0 : _a.dispose();
                    delete chartInstances[id];
                });
                Object.keys(chartObservers).forEach(id => {
                    var _a;
                    (_a = chartObservers[id]) === null || _a === void 0 ? void 0 : _a.disconnect();
                    delete chartObservers[id];
                });
                Object.keys(renderFrames).forEach(id => {
                    cancelAnimationFrame(renderFrames[id]);
                    delete renderFrames[id];
                });
            }
            charts.disposeAll = disposeAll;
            function render(element, component) {
                const chartEl = element.find('.chart').get(0);
                if (!chartEl)
                    return;
                if (renderFrames[component.id])
                    cancelAnimationFrame(renderFrames[component.id]);
                const performUpdate = () => {
                    var _a;
                    let chart = chartInstances[component.id];
                    if (chart && chart.getDom() !== chartEl) {
                        chart.dispose();
                        (_a = chartObservers[component.id]) === null || _a === void 0 ? void 0 : _a.disconnect();
                        delete chartObservers[component.id];
                        delete chartInstances[component.id];
                        chart = undefined;
                    }
                    if (!chart) {
                        const created = echarts.init(chartEl);
                        chart = created;
                        chartInstances[component.id] = created;
                        const rootContainer = element.get(0);
                        const cardBody = element.find('.card-body').get(0);
                        if (rootContainer) {
                            const observer = new ResizeObserver(() => {
                                created.resize();
                            });
                            observer.observe(rootContainer);
                            if (cardBody) {
                                observer.observe(cardBody);
                            }
                            chartObservers[component.id] = observer;
                        }
                    }
                    const chartData = resolveAndTransformData(component);
                    const options = buildOptions(component, chartData);
                    chart.dispatchAction({ type: 'hideTip' });
                    chart.setOption(options, true);
                    delete renderFrames[component.id];
                };
                renderFrames[component.id] = requestAnimationFrame(performUpdate);
            }
            charts.render = render;
            function buildOptions(component, data) {
                const options = {
                    tooltip: { trigger: 'item', confine: true, appendTo: 'body' },
                    series: []
                };
                const colors = resolveColors(component);
                const ctx = { component, data, options, colors };
                composeSharedTitle(ctx);
                composeSharedTooltip(ctx);
                composeSharedLegend(ctx);
                if (component.type === dashboards.ComponentType.pieChart) {
                    composePieSeries(ctx);
                }
                else {
                    composeCartesianLayout(ctx);
                    composeCartesianAxes(ctx);
                    composeCartesianSeries(ctx);
                }
                return options;
            }
            function composeSharedTitle(ctx) {
                const { data, options } = ctx;
                if (data.errorMessage) {
                    options.title = {
                        text: `Data Error: ${data.errorMessage}`,
                        left: 'center', top: 'center',
                        textStyle: { color: '#D32F2F', fontSize: 12 }
                    };
                }
                else if (!data.hasRealData) {
                    options.title = {
                        text: 'Example Data', subtext: 'Configure chart to view actual data',
                        left: 'center', top: 'center',
                        textStyle: { color: '#999' }
                    };
                }
                else if (data.series.length === 0) {
                    options.title = {
                        text: 'No Data Found',
                        left: 'center', top: 'center',
                        textStyle: { color: '#666' }
                    };
                }
            }
            function resolveFormatter(component, type) {
                var _a, _b;
                const styling = component.styling || {};
                let config;
                if (type === 'dataLabel')
                    config = styling.dataLabelValueFormatting;
                else if (type === 'legend')
                    config = styling.legendValueFormatting;
                else if (type === 'tooltip')
                    config = styling.tooltipValueFormatting;
                else if (type === 'yAxis')
                    config = styling.yAxisValueFormatting;
                else if (type === 'xAxis')
                    config = styling.xAxisValueFormatting;
                const defaultFormat = (type === 'legend' || type === 'xAxis') ? 'Category' : (type === 'tooltip' ? 'Category: Value' : 'Value');
                const format = (config === null || config === void 0 ? void 0 : config.format) || defaultFormat;
                const factor = (_a = config === null || config === void 0 ? void 0 : config.factor) !== null && _a !== void 0 ? _a : 1;
                const decimals = (_b = config === null || config === void 0 ? void 0 : config.decimals) !== null && _b !== void 0 ? _b : 0;
                const prefix = (config === null || config === void 0 ? void 0 : config.prefix) || '';
                const suffix = (config === null || config === void 0 ? void 0 : config.suffix) || '';
                const formatValue = (val) => {
                    if (val === null || val === undefined)
                        return '-';
                    let num = Number(val);
                    if (isNaN(num))
                        return `${prefix}${val}${suffix}`;
                    num = num * factor;
                    const localeStr = num.toLocaleString(undefined, {
                        minimumFractionDigits: decimals,
                        maximumFractionDigits: decimals
                    });
                    return `${prefix}${localeStr}${suffix}`;
                };
                return (params) => {
                    var _a, _b, _c;
                    let rawVal;
                    if (params && typeof params === 'object' && 'value' in params) {
                        rawVal = params.value;
                        if (Array.isArray(rawVal) && component.type !== dashboards.ComponentType.pieChart) {
                            const yIndex = (_c = (_b = (_a = params.encode) === null || _a === void 0 ? void 0 : _a.y) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : 1;
                            rawVal = rawVal[yIndex];
                        }
                    }
                    else
                        rawVal = params;
                    const valStr = formatValue(rawVal);
                    if (type === 'yAxis' || type === 'xAxis')
                        return valStr;
                    const pctStr = (params && params.percent) ? `${params.percent}%` : '';
                    const nameStr = (params && params.name) ? params.name : '';
                    switch (format) {
                        case 'Category': return nameStr;
                        case 'Value': return valStr;
                        case 'Percent': return pctStr;
                        case 'Category: Value': return `${nameStr}: ${valStr}`;
                        case 'Category: Percent': return `${nameStr}: ${pctStr}`;
                        case 'Category: Value (Percent)': return `${nameStr}: ${valStr} (${pctStr})`;
                        case 'Value (Percent)': return `${valStr} (${pctStr})`;
                        default: return valStr;
                    }
                };
            }
            function composeSharedTooltip(ctx) {
                var _a, _b;
                const { options, component } = ctx;
                const styling = component.styling || {};
                const triggerPref = styling.tooltipTrigger;
                let trigger = 'item';
                if (triggerPref === 'None')
                    trigger = 'none';
                else if (triggerPref === 'Axis')
                    trigger = 'axis';
                else if (component.type === dashboards.ComponentType.pieChart)
                    trigger = 'item';
                const bgColor = dashboards.hexToRgba(styling.tooltipBgColor || '#323232', (_a = styling.tooltipBgOpacity) !== null && _a !== void 0 ? _a : 95);
                const textStyle = mapFontStyleToECharts((_b = styling.tooltipValueFormatting) === null || _b === void 0 ? void 0 : _b.textStyle, '#ffffff');
                const formatter = resolveFormatter(component, 'tooltip');
                options.tooltip = {
                    show: trigger !== 'none',
                    trigger: trigger,
                    backgroundColor: bgColor,
                    textStyle: textStyle,
                    borderWidth: 0,
                    padding: 10,
                    confine: true,
                    appendTo: 'body',
                    formatter: (params) => {
                        if (Array.isArray(params)) {
                            let html = `<div style="font-weight:bold;margin-bottom:5px">${params[0].name}</div>`;
                            params.forEach(p => {
                                html += `<div>${p.marker} ${formatter(p)}</div>`;
                            });
                            return html;
                        }
                        else
                            return `${params.marker} ${formatter(params)}`;
                    }
                };
            }
            function composeSharedLegend(ctx) {
                var _a, _b, _c, _d, _e;
                const { component, options } = ctx;
                if (((_a = component.layout) === null || _a === void 0 ? void 0 : _a.showLegend) === false) {
                    options.legend = { show: false };
                    return;
                }
                const style = ((_b = component.layout) === null || _b === void 0 ? void 0 : _b.legendStyle) || {};
                const styling = component.styling || {};
                let left = 'center', top = 'auto', bottom = 'auto', right = 'auto';
                let orient = 'horizontal';
                if (style.verticalPosition === 'middle')
                    orient = 'vertical';
                if (style.horizontalPosition === 'left')
                    left = '0%';
                else if (style.horizontalPosition === 'right') {
                    left = 'auto';
                    right = '0%';
                }
                if (style.verticalPosition === 'top')
                    top = '0%';
                else if (style.verticalPosition === 'middle')
                    top = 'middle';
                else
                    bottom = '0%';
                const outlineColor = styling.outlineColor || '#ffffff';
                const textStyle = mapFontStyleToECharts((_c = styling.legendValueFormatting) === null || _c === void 0 ? void 0 : _c.textStyle, '#666666');
                const legendValueMap = {};
                if (component.type === dashboards.ComponentType.pieChart && ((_e = (_d = options.series) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.data)) {
                    options.series[0].data.forEach((d) => {
                        if (d.name)
                            legendValueMap[d.name] = d.value;
                    });
                }
                else if (ctx.data.series) {
                    ctx.data.series.forEach(s => {
                        if (s.name) {
                            legendValueMap[s.name] = s.data.reduce((acc, val) => acc + (val || 0), 0);
                        }
                    });
                }
                const baseFormatter = resolveFormatter(component, 'legend');
                const legendFormatter = (name) => {
                    const val = legendValueMap[name];
                    if (val !== undefined) {
                        return baseFormatter({ name: name, value: val });
                    }
                    return baseFormatter({ name: name });
                };
                options.legend = {
                    show: true,
                    type: 'scroll',
                    orient: orient,
                    left, right, top, bottom,
                    textStyle: textStyle,
                    itemStyle: {
                        borderColor: outlineColor,
                        borderWidth: 2
                    },
                    formatter: legendFormatter
                };
            }
            function composeCartesianLayout(ctx) {
                var _a, _b, _c, _d;
                const { component, options } = ctx;
                const layout = component.layout || {};
                let top = (_a = layout.chartMarginTop) !== null && _a !== void 0 ? _a : 15;
                let bottom = (_b = layout.chartMarginBottom) !== null && _b !== void 0 ? _b : 10;
                let left = (_c = layout.chartMarginLeft) !== null && _c !== void 0 ? _c : 10;
                let right = (_d = layout.chartMarginRight) !== null && _d !== void 0 ? _d : 10;
                options.grid = {
                    top: top + '%',
                    bottom: bottom + '%',
                    left: left + '%',
                    right: right + '%',
                    containLabel: true
                };
            }
            function composeCartesianAxes(ctx) {
                var _a, _b, _c, _d;
                const { component, data, options } = ctx;
                const styling = component.styling || {};
                const layout = component.layout || {};
                const isBar = component.type === dashboards.ComponentType.barChart;
                const xAxisFormatter = resolveFormatter(component, 'xAxis');
                const xAxisStyle = mapFontStyleToECharts((_a = styling.xAxisValueFormatting) === null || _a === void 0 ? void 0 : _a.textStyle, '#666666');
                options.xAxis = {
                    type: 'category',
                    data: data.labels,
                    boundaryGap: isBar,
                    axisLabel: {
                        rotate: styling.xAxisLabelRotation || 0,
                        color: xAxisStyle.color,
                        fontSize: xAxisStyle.fontSize,
                        fontWeight: xAxisStyle.fontWeight,
                        fontStyle: xAxisStyle.fontStyle,
                        interval: 'auto',
                        formatter: xAxisFormatter
                    },
                    axisLine: { lineStyle: { color: '#ccc' } },
                    axisTick: { show: false }
                };
                const isLog = styling.yAxisScale === 'Logarithmic';
                const yAxisFormatter = resolveFormatter(component, 'yAxis');
                const yAxisStyle = mapFontStyleToECharts((_b = styling.yAxisValueFormatting) === null || _b === void 0 ? void 0 : _b.textStyle, '#666666');
                const commonY = {
                    type: isLog ? 'log' : 'value',
                    min: (_c = layout.yAxisMin) !== null && _c !== void 0 ? _c : undefined,
                    max: (_d = layout.yAxisMax) !== null && _d !== void 0 ? _d : undefined,
                    nameTextStyle: { color: '#999', padding: [0, 0, 0, 10] },
                    axisLabel: {
                        color: yAxisStyle.color,
                        fontSize: yAxisStyle.fontSize,
                        fontWeight: yAxisStyle.fontWeight,
                        fontStyle: yAxisStyle.fontStyle,
                        formatter: yAxisFormatter
                    },
                    splitLine: {
                        show: styling.yAxisGridLines !== 'None',
                        lineStyle: { type: 'dashed', color: '#eee' }
                    },
                    axisLine: { show: false },
                    axisTick: { show: false }
                };
                options.yAxis = [
                    Object.assign(Object.assign({}, commonY), { name: styling.yAxisLeftTitle }),
                ];
            }
            function composeCartesianSeries(ctx) {
                var _a;
                const { component, data, options, colors } = ctx;
                const styling = component.styling || {};
                const layout = component.layout || {};
                const isStacked = layout.stackingMode === 'Normal';
                const isArea = layout.chartStyle === 'Area';
                const labelFormatter = resolveFormatter(component, 'dataLabel');
                const labelTextStyle = mapFontStyleToECharts((_a = styling.dataLabelValueFormatting) === null || _a === void 0 ? void 0 : _a.textStyle, '#333333');
                const markerStyle = layout.markerStyle || 'Cycle';
                const showSymbol = markerStyle !== 'None';
                const forceSymbol = markerStyle === 'Circle' ? 'circle' : undefined;
                const markLineData = [];
                if (layout.referenceLines && layout.referenceLines.length > 0) {
                    layout.referenceLines.forEach(ref => {
                        const item = {
                            label: { formatter: ref.label || '', position: 'end', color: ref.color || '#333' },
                            lineStyle: { color: ref.color || '#333', type: ref.lineStyle || 'dashed', width: 2 }
                        };
                        if (ref.type === 'Constant')
                            item.yAxis = ref.value;
                        else {
                            const calcVal = calculateReferenceValue(ref.type, data.series, isStacked);
                            if (calcVal !== undefined)
                                item.yAxis = calcVal;
                        }
                        if (item.yAxis !== undefined)
                            markLineData.push(item);
                    });
                }
                const LINE_STYLES = ['solid', 'dashed', 'dotted'];
                const SYMBOLS = ['circle', 'rect', 'triangle', 'diamond', 'pin', 'arrow'];
                data.series.forEach((s, index) => {
                    var _a, _b, _c;
                    const color = colors[index % colors.length];
                    const lineStyleIndex = index % LINE_STYLES.length;
                    const symbolIndex = Math.floor(index / LINE_STYLES.length) % SYMBOLS.length;
                    const seriesItem = {
                        name: s.name,
                        type: component.type === dashboards.ComponentType.lineChart ? 'line' : 'bar',
                        data: s.data,
                        yAxisIndex: 0,
                        itemStyle: { color: color },
                        label: {
                            show: layout.showDataLabels,
                            position: 'top',
                            formatter: labelFormatter,
                            color: labelTextStyle.color,
                            fontSize: labelTextStyle.fontSize,
                            fontWeight: labelTextStyle.fontWeight,
                            fontStyle: labelTextStyle.fontStyle
                        }
                    };
                    if (seriesItem.type === 'line') {
                        seriesItem.smooth = (_a = layout.lineSmooth) !== null && _a !== void 0 ? _a : false;
                        seriesItem.connectNulls = (_b = layout.connectNulls) !== null && _b !== void 0 ? _b : true;
                        seriesItem.showSymbol = showSymbol;
                        seriesItem.symbol = forceSymbol || SYMBOLS[symbolIndex];
                        seriesItem.symbolSize = 8;
                        seriesItem.lineStyle = {
                            type: LINE_STYLES[lineStyleIndex],
                            width: (_c = layout.lineWidth) !== null && _c !== void 0 ? _c : 2
                        };
                        if (isStacked)
                            seriesItem.stack = 'total';
                        if (isArea) {
                            seriesItem.areaStyle = {
                                opacity: 0.3,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    { offset: 0, color: color },
                                    { offset: 1, color: 'rgba(255, 255, 255, 0)' }
                                ])
                            };
                        }
                    }
                    else {
                        if (isStacked)
                            seriesItem.stack = 'total';
                        seriesItem.barMaxWidth = 20;
                    }
                    if (index === 0 && markLineData.length > 0) {
                        seriesItem.markLine = {
                            data: markLineData,
                            symbol: ['none', 'none'],
                            silent: true,
                            animation: false
                        };
                    }
                    options.series.push(seriesItem);
                });
            }
            function composePieSeries(ctx) {
                var _a, _b, _c, _d, _e;
                const { component, data, options, colors } = ctx;
                const layout = component.layout || {};
                const styling = component.styling || {};
                if (data.series.length === 0)
                    return;
                const primarySeries = data.series[0];
                const pieData = primarySeries.data.map((val, idx) => ({
                    name: data.labels[idx],
                    value: val
                }));
                const isDoughnut = layout.chartStyle === 'Doughnut';
                const useCustomGeom = layout.enableCustomGeometry === true;
                const defaultOuter = 75;
                const defaultInner = isDoughnut ? 45 : 0;
                const defaultCx = 50;
                const defaultCy = 50;
                const finalOuter = useCustomGeom ? ((_a = layout.pieOuterRadius) !== null && _a !== void 0 ? _a : defaultOuter) : defaultOuter;
                const finalInner = (isDoughnut && useCustomGeom) ? ((_b = layout.pieInnerRadius) !== null && _b !== void 0 ? _b : 45) : defaultInner;
                const finalCx = useCustomGeom ? ((_c = layout.pieCenterX) !== null && _c !== void 0 ? _c : defaultCx) : defaultCx;
                const finalCy = useCustomGeom ? ((_d = layout.pieCenterY) !== null && _d !== void 0 ? _d : defaultCy) : defaultCy;
                const outlineColor = styling.outlineColor || '#ffffff';
                const labelFormatter = resolveFormatter(component, 'dataLabel');
                const labelTextStyle = mapFontStyleToECharts((_e = styling.dataLabelValueFormatting) === null || _e === void 0 ? void 0 : _e.textStyle, '#333333');
                options.series.push({
                    name: primarySeries.name,
                    type: 'pie',
                    radius: [`${finalInner}%`, `${finalOuter}%`],
                    center: [`${finalCx}%`, `${finalCy}%`],
                    roseType: (layout.roseType && layout.roseType !== 'None') ? layout.roseType.toLowerCase() : undefined,
                    avoidLabelOverlap: true,
                    itemStyle: {
                        borderRadius: 5,
                        borderColor: outlineColor,
                        borderWidth: 2
                    },
                    label: {
                        show: layout.showDataLabels,
                        formatter: labelFormatter,
                        distanceToLabelLine: 5,
                        color: labelTextStyle.color,
                        fontSize: labelTextStyle.fontSize,
                        fontWeight: labelTextStyle.fontWeight,
                        fontStyle: labelTextStyle.fontStyle
                    },
                    labelLine: {
                        show: layout.showDataLabels,
                        length: 10,
                        length2: 10,
                        smooth: 0.2
                    },
                    labelLayout: {
                        hideOverlap: true
                    },
                    data: pieData
                });
                options.color = colors;
            }
            function resolveAndTransformData(component) {
                let rawData = null;
                let dataQuery;
                const definition = distill.componentManager.getDefinition(component.type);
                if (definition) {
                    const props = distill.componentManager.getDataQueryPropertyNames(definition);
                    for (const name of props) {
                        const d = component[name];
                        const cache = dashboards.dataManager.getCachedResult(`${component.id}.${name}`);
                        if (cache) {
                            rawData = cache;
                            dataQuery = d;
                            break;
                        }
                    }
                }
                if (!rawData)
                    return getMockData(component);
                return transformRealData(rawData, dataQuery, component);
            }
            function transformRealData(result, dataQuery, component) {
                var _a;
                const rows = result.ObjectResult || [];
                const agg = dataQuery.aggregation;
                if (!agg)
                    return { labels: [], series: [], hasRealData: true };
                const groupByCol = agg.groupBy;
                const groupByHeader = dashboards.getHeaderName(groupByCol, component);
                const breakDownCol = agg.breakDownBy;
                const breakDownHeader = breakDownCol ? dashboards.getHeaderName(breakDownCol, component) : null;
                const metrics = agg.metrics || [];
                const labelSet = new Set();
                const rowMap = new Map();
                rows.forEach(r => {
                    if (r[groupByHeader] != null) {
                        const label = String(r[groupByHeader]);
                        labelSet.add(label);
                        if (breakDownHeader && r[breakDownHeader] != null) {
                            const bdVal = String(r[breakDownHeader]);
                            rowMap.set(`${label}|${bdVal}`, r);
                        }
                        else
                            rowMap.set(label, r);
                    }
                });
                let orderedLabels = Array.from(labelSet);
                const displaySortOrders = (_a = component.layout) === null || _a === void 0 ? void 0 : _a.displaySortOrders;
                if (displaySortOrders && displaySortOrders.length > 0)
                    orderedLabels = sortLabels(orderedLabels, displaySortOrders, rows, groupByHeader, component, dataQuery);
                else
                    orderedLabels.sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));
                const finalLabels = orderedLabels.map(l => dashboards.formatDateByGrain(l, groupByCol === null || groupByCol === void 0 ? void 0 : groupByCol.timeGrain));
                const seriesList = [];
                if (breakDownHeader) {
                    const distinctBreakdowns = Array.from(new Set(rows.map(r => String(r[breakDownHeader])))).sort();
                    distinctBreakdowns.forEach(bdVal => {
                        metrics.forEach((m, mIdx) => {
                            const header = dashboards.getExpectedMetricHeader(component, dataQuery, m, mIdx);
                            const dataPoints = orderedLabels.map(lbl => {
                                const row = rowMap.get(`${lbl}|${bdVal}`);
                                return row && row[header] !== undefined ? Number(row[header]) : null;
                            });
                            seriesList.push({
                                name: `${bdVal} - ${m.alias || header}`,
                                data: dataPoints,
                                metricConfig: m,
                                breakdownValue: bdVal
                            });
                        });
                    });
                }
                else {
                    metrics.forEach((m, mIdx) => {
                        const header = dashboards.getExpectedMetricHeader(component, dataQuery, m, mIdx);
                        const dataPoints = orderedLabels.map(lbl => {
                            const row = rowMap.get(lbl);
                            return row && row[header] !== undefined ? Number(row[header]) : null;
                        });
                        seriesList.push({
                            name: m.alias || header,
                            data: dataPoints,
                            metricConfig: m
                        });
                    });
                }
                return {
                    labels: finalLabels,
                    series: seriesList,
                    hasRealData: true,
                    errorMessage: result.Error || undefined
                };
            }
            function sortLabels(labels, sortOrders, rows, groupByHeader, component, dataQuery) {
                const metricSorts = sortOrders.filter(s => appn.utils.hasValue(s.metricIndex));
                const labelMetricMaps = new Map();
                metricSorts.forEach(s => {
                    var _a, _b;
                    if (labelMetricMaps.has(s.metricIndex))
                        return;
                    const metric = (_b = (_a = dataQuery.aggregation) === null || _a === void 0 ? void 0 : _a.metrics) === null || _b === void 0 ? void 0 : _b[s.metricIndex];
                    if (!metric)
                        return;
                    const metricHeader = dashboards.getExpectedMetricHeader(component, dataQuery, metric, s.metricIndex);
                    const map = new Map();
                    rows.forEach(r => {
                        const key = String(r[groupByHeader]);
                        const val = Number(r[metricHeader]);
                        const current = map.get(key) || 0;
                        map.set(key, current + (isNaN(val) ? 0 : val));
                    });
                    labelMetricMaps.set(s.metricIndex, map);
                });
                const sorted = [...labels];
                sorted.sort((a, b) => {
                    var _a, _b;
                    for (const order of sortOrders) {
                        let comparison = 0;
                        const isDesc = order.type === 'Desc';
                        if (order.column && order.column.columnId === ((_b = (_a = dataQuery.aggregation) === null || _a === void 0 ? void 0 : _a.groupBy) === null || _b === void 0 ? void 0 : _b.columnId))
                            comparison = a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
                        else if (appn.utils.hasValue(order.metricIndex)) {
                            const map = labelMetricMaps.get(order.metricIndex);
                            const valA = (map === null || map === void 0 ? void 0 : map.get(a)) || 0;
                            const valB = (map === null || map === void 0 ? void 0 : map.get(b)) || 0;
                            comparison = valA - valB;
                        }
                        if (comparison !== 0)
                            return isDesc ? -comparison : comparison;
                    }
                    return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
                });
                return sorted;
            }
            function resolveColors(component) {
                var _a, _b, _c, _d;
                if (((_a = component.styling) === null || _a === void 0 ? void 0 : _a.colorPalette) === 'Custom' && ((_c = (_b = component.styling) === null || _b === void 0 ? void 0 : _b.customColorPalette) === null || _c === void 0 ? void 0 : _c.length))
                    return component.styling.customColorPalette;
                const paletteName = ((_d = component.styling) === null || _d === void 0 ? void 0 : _d.colorPalette) || 'Vibrant';
                return dashboards.DashColorPalettes[paletteName] || dashboards.DashColorPalettes['Vibrant'];
            }
            function getMockData(component) {
                if (component.type === dashboards.ComponentType.pieChart) {
                    return {
                        labels: ['Electronics', 'Books', 'Apparel', 'Home'],
                        series: [{ name: 'Sales', data: [335, 310, 234, 135], metricConfig: {} }],
                        hasRealData: false
                    };
                }
                return {
                    labels: ['Jan', 'Feb', 'Mar', 'Apr'],
                    series: [{ name: 'Users', data: [820, 932, 901, 934], metricConfig: {} }],
                    hasRealData: false
                };
            }
            function mapFontStyleToECharts(style, defaultColor = '#333') {
                if (!style)
                    return { color: defaultColor };
                const sizeMap = {
                    'Small': 12,
                    'Medium': 14,
                    'Large': 16
                };
                return {
                    color: style.color || defaultColor,
                    fontSize: sizeMap[style.size || 'Medium'] || 12,
                    fontWeight: style.decor === 'Bold' ? 'bold' : 'normal',
                    fontStyle: style.decor === 'Italic' ? 'italic' : 'normal'
                };
            }
            function calculateReferenceValue(type, series, isStacked) {
                if (!series || series.length === 0)
                    return undefined;
                const values = [];
                if (isStacked) {
                    const pointCount = series[0].data.length;
                    for (let i = 0; i < pointCount; i++) {
                        let sum = 0;
                        let hasData = false;
                        series.forEach(s => {
                            const v = s.data[i];
                            if (v != null && typeof v === 'number' && !isNaN(v)) {
                                sum += v;
                                hasData = true;
                            }
                        });
                        if (hasData)
                            values.push(sum);
                    }
                }
                else {
                    series.forEach(s => {
                        s.data.forEach((v) => {
                            if (v != null && typeof v === 'number' && !isNaN(v))
                                values.push(v);
                        });
                    });
                }
                if (values.length === 0)
                    return undefined;
                switch (type) {
                    case 'Average': return values.reduce((a, b) => a + b, 0) / values.length;
                    case 'Min': return values.reduce((a, b) => a < b ? a : b);
                    case 'Max': return values.reduce((a, b) => a > b ? a : b);
                    default: return undefined;
                }
            }
        })(charts = dashboards.charts || (dashboards.charts = {}));
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
